import { InstallationAndPowerSource } from "./customer.model";
import { Meter, TypeOfMeter } from "./meter.model";
import { ServiceRequestHistoryDataOut } from "../_modules/customers/_models/kyc-account-data";

export class InstallationTableData {
  id : number = 0;
  accountNumber: string = '';
  accountName: string = '';
  address: string = '';
  currentTariff: string = '';
  region: string = '';
  district: string = '';
  feederName: string = '';
  dtName: string = '';
  dtNumber: string = '';
  dtType: string = '';
  rating: string = '';
  geographicalRegion: string = '';
  subgeographicalRegion: string = '';
  acLineName: string = '';
  substationName: string = '';
  meterNumber: string = '';
  assignedDate: string = '';
  submittedDate: string = '';
  approvedDate :string='';
  rejectedDate:string='';
  assignedUser: string = '';
  assignedBy: string = '';
  approvedBy: string='';
  rejectedBy : string = '';
  currentStatus: string = '';
  mapId: string = '';
  projectType: string = '';
  oldMeterNumber: string = '';
  mapVendorName: string = '';
  subServiceType: string = '';
  installationDate: string = '';
  meterPrice: string = '';
  reopenStatus: string = '';
}
export enum SortByOptions {
  NEWEST = 1,
  OLDEST = 2
}
export class InstallationMaterialRequirements {
  id: number = 0;
  installationMaterial: string = '';
  materialCategory: string = '';
  quantity: number = 0;
  unitOfMeasurement: string = '';

  constructor(data?: any) {
    this.id = data?.id ?? 0;
    this.installationMaterial = data?.installationMaterial ?? '';
    this.materialCategory = data?.materialCategory ?? '';
    this.quantity = data?.quantity ?? 0;
    this.unitOfMeasurement = data?.unitOfMeasurement ?? '';
  }
}
export class InstallationAssign{
  assignedUserId :number=0;
  customers:number[]=[];
}

export class AssetInstallationAssign{
  assignedUserId :number=0;
  assets:number[]=[];
}

export class VendorInstallationAssign{
  organizationId :number=0;
  assets:number[]=[];
}

export class AssetForInstallationAssign{
  id: number = 0;
  name: string = '';
  slrn: string = '';
  number: string = '';
  areaId: number | null = null;
  organizationId: number | null = null;
  meterNumber: string = '';
  address: string = '';
}

export class InstallationDetails{
  existingCableSize: string = '';
  existingMeterEnclosure: string = '';
  inputCableDistance: string = '';
  installationType: string = '';
  meterLocation: string = '';
  numberOfServiceWires: string = '';
  outputCableDistance: string = '';
  recommendedCableSize: string = '';
  recommendedMeterType: string = '';
  serviceWireTraceableToMeterPoint: string = '';
  serviceWiresCondition: string = '';
  installationStatus: string = '';
  remarksAndRecommendations: string = '';
  existingMeterInLocation:string='';
  rejectionNote:string = "";
  reviewedBy:string = "";
  username : string = "";
  tagSerialNumber: string = '';
  instrumentSerialNumber: string = '';
  ctvtCtRating: string = '';
  ctvtVtRating: string = '';
  dt: InstallationDt = new InstallationDt();
  substation: InstallationSubstation = new InstallationSubstation();
  customer: InstallationCustomer = new InstallationCustomer();
  installationMaterialRequirements: InstallationMaterialRequirements[] = [];
  images : InstallationImage[] = [];
  latitude: number;
  longitude: number;
  installationFormUrl: string;
  comments: string;
  installationHistory: InstallationHistory[] = [];
  serviceRequestHistory: ServiceRequestHistoryDataOut[] = [];
  constructor(data?: any) {
    this.existingCableSize = data?.existingCableSize ?? '';
    this.existingMeterEnclosure = data?.existingMeterEnclosure ?? '';
    this.inputCableDistance = data?.inputCableDistance ?? '';
    this.installationType = data?.installationType ?? '';
    this.meterLocation = data?.meterLocation ?? '';
    this.numberOfServiceWires = data?.numberOfServiceWires ?? '';
    this.outputCableDistance = data?.outputCableDistance ?? '';
    this.recommendedCableSize = data?.recommendedCableSize ?? '';
    this.recommendedMeterType = data?.recommendedMeterType ?? '';
    this.serviceWireTraceableToMeterPoint = data?.serviceWireTraceableToMeterPoint ?? '';
    this.serviceWiresCondition = data?.serviceWiresCondition ?? '';
    this.installationStatus = data?.installationStatus ?? '';
    this.remarksAndRecommendations = data?.remarksAndRecommendations ?? '';
    this.existingMeterInLocation = data?.existingMeterInLocation ?? '';
    this.reviewedBy = data?.reviewedBy ?? '';
    this.rejectionNote = data?.rejectionNote ?? '';
    this.username = data?.username ?? '';
    this.tagSerialNumber = data?.tagSerialNumber ?? '';
    this.instrumentSerialNumber = data?.instrumentSerialNumber ?? '';
    this.ctvtCtRating = data?.ctvtCtRating ?? '';
    this.ctvtVtRating = data?.ctvtVtRating ?? '';
    this.dt = new InstallationDt(data?.dt);
    this.substation = new InstallationSubstation(data?.substation);
    this.customer = new InstallationCustomer(data?.customer);
    this.installationMaterialRequirements = data?.installationMaterialRequirements?.length ? data?.installationMaterialRequirements.map((el: any) => new InstallationMaterialRequirements(el)) : [];
    this.images = data?.images?.length ? data?.images.map((el: any) => new InstallationImage(el)) : [];
    this.latitude = data?.latitude ?? 0;
    this.longitude = data?.longitude ?? 0;
    this.installationFormUrl = data?.installationFormUrl ?? '';
    this.comments = data?.comments ?? '';
    this.installationHistory = data?.installationHistory?.length ? data?.installationHistory.map((el: any) => new InstallationHistory(el)) : []
    this.serviceRequestHistory = [...(data?.serviceRequestHistory ?? [])].sort((a: ServiceRequestHistoryDataOut, b: ServiceRequestHistoryDataOut) =>
      new Date(b.applicationDate ?? 0).getTime() - new Date(a.applicationDate ?? 0).getTime()
    );
  }
}
export class DtInstallationDetails {
  installationStatus: string = '';
  dtName: string = '';
  dtNumber: string = '';
  address: string = '';
  meterStatus: string = '';
  dtType: string = '';
  feederNumber: string = '';
  feederName: string = '';
  regionName: string = '';
  areaName: string = '';
  oldMeterStatus: string = '';
  oldMeterMake: string = '';
  oldMeterNumber: string = '';
  oldMeterType: string = '';
  oldMeterCondition: string = '';
  kwhReadingOldMeter: string = '';
  oldMeterBoxSeal: string = '';
  oldMeterSeal: string = '';
  oldTTBSeal: string = '';
  oldCTSeal: string = '';
  newMeterNumber: string = '';
  newMeterType: string = '';
  newMeterMake: string = '';
  newMeterModel: string = '';
  newMeterRating: string = '';
  newCTBoxSeal: string = '';
  newTTBSeal: string = '';
  newMeterSeal: string = '';
  newMeterBoxSeal: string = '';
  newCTRating: string = '';
  tagSerialNumber: string = '';
  instrumentSerialNumber: string = '';
  newVTRating: string = '';
  comments: string = '';
  images: InstallationImage[] = [];
  installationHistory: InstallationHistory[] = [];
  installationDate: string = '';
  vendor: string = '';
  meterPrice: string = '';

  constructor(data?: any) {
    this.installationStatus = data?.installationStatus ?? '';
    this.dtName = data?.dtName ?? '';
    this.dtNumber = data?.dtNumber ?? '';
    this.address = data?.address ?? '';
    this.meterStatus = data?.meterStatus ?? '';
    this.dtType = data?.dtType ?? '';
    this.feederNumber = data?.feederNumber ?? '';
    this.feederName = data?.feederName ?? '';
    this.regionName = data?.regionName ?? '';
    this.areaName = data?.areaName ?? '';
    this.oldMeterStatus = data?.oldMeterStatus ?? '';
    this.oldMeterMake = data?.oldMeterMake ?? '';
    this.oldMeterNumber = data?.oldMeterNumber ?? '';
    this.oldMeterType = data?.oldMeterType ?? '';
    this.oldMeterCondition = data?.oldMeterCondition ?? '';
    this.kwhReadingOldMeter = data?.kwhReadingOldMeter ?? '';
    this.oldMeterBoxSeal = data?.oldMeterBoxSeal ?? '';
    this.oldMeterSeal = data?.oldMeterSeal ?? '';
    this.oldTTBSeal = data?.oldTTBSeal ?? '';
    this.oldCTSeal = data?.oldCTSeal ?? '';
    this.newMeterNumber = data?.newMeterNumber ?? '';
    this.newMeterType = data?.newMeterType ?? '';
    this.newMeterMake = data?.newMeterMake ?? '';
    this.newMeterModel = data?.newMeterModel ?? '';
    this.newMeterRating = data?.newMeterRating ?? '';
    this.newCTBoxSeal = data?.newCTBoxSeal ?? '';
    this.newTTBSeal = data?.newTTBSeal ?? '';
    this.newMeterSeal = data?.newMeterSeal ?? '';
    this.newMeterBoxSeal = data?.newMeterBoxSeal ?? '';
    this.newCTRating = data?.newCTRating ?? '';
    this.tagSerialNumber = data?.tagSerialNumber ?? '';
    this.instrumentSerialNumber = data?.instrumentSerialNumber ?? '';
    this.newVTRating = data?.newVTRating ?? '';
    this.comments = data?.comments ?? '';
    this.images = data?.images?.length ? data?.images.map((el: any) => new InstallationImage(el)) : [];
    this.installationHistory = data?.installationHistory?.length ? data?.installationHistory.map((el: any) => new InstallationHistory(el)) : [];
    this.installationDate = data?.installationDate ?? '';
    this.vendor = data?.vendor ?? '';
    this.meterPrice = data?.meterPrice ?? '';
  }
}
export class InstallationImage {
  url: string;
  imageType: any;
  latitude?: number;
  longitude?: number;
  physicalAddress?: string;
  lastUpdateTime?: string;

  constructor(data?: any) {
    this.url = data?.url ?? '';
    this.imageType = data?.imageType ?? '';
    this.latitude = data?.latitude;
    this.longitude = data?.longitude;
    this.physicalAddress = data?.physicalAddress;
    this.lastUpdateTime = data?.lastUpdateTime;
  }
}
export class InstallationDt {
  dtId: string = '';
  dtName: string = '';
  dtNumber: string = '';
  feederId: string = '';
  feederName: string = '';
  feederNumber: string = '';
  isFeeder11 : string = '';

  constructor(data?: any) {
    this.dtId = data?.dtId ?? '';
    this.dtName = data?.dtName ?? '';
    this.dtNumber = data?.dtNumber ?? '';
    this.feederId = data?.feederId ?? '';
    this.feederName = data?.feederName ?? '';
    this.feederNumber = data?.feederNumber ?? '';
    this.isFeeder11 = data?.isFeeder11 ?? '';
  }
}
export class InstallationSubstation {
  id: string = '';
  name: string = '';
  number: string = '';
  acLineName: string = '';
  acLineNumber: string = '';
  injectionSubstation: string = '';
  acLineVoltageClass : string = '';

  constructor(data?: any) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
    this.number = data?.number ?? '';
    this.acLineName = data?.acLineName ?? '';
    this.acLineNumber = data?.acLineNumber ?? '';
    this.injectionSubstation = data?.injectionSubstation ?? '';
    this.acLineVoltageClass = data?.acLineVoltageClass ?? '';
  }
}

export class InstallationCustomer {
  accountName: string = '';
  accountNumber: string = '';
  address: string = '';
  physicalAddress: string = '';
  areaName: string = '';
  buildingOwner: string = '';
  customerId: 3;
  customerType: string = '';
  email: string = '';
  latitude: number = 0;
  longitude: number = 0;
  meterStatus: string = '';
  name: string = '';
  oldMeter: Meter;
  regionName: string = '';
  spn: string = '';
  tarifId: number = 0;
  tarifName: string = '';
  tarifRate: string = '';
  typeOfConnection: string = '';
  geoCode: string = '';
  readingOnMeter: string = '';
  ghanaPostGPS: string = '';
  activityCode: string = '';
  currentPlotCode: string = '';
  meterManufacturer:string='';
  meterSealNumber:string = '';
  meterSimNo:string = '';
  meterSerialNumber :string= "";
  meterType:string='';
  meterNumber: string = '';
  sltStatus: string = '';
  installationAndPowerSource: InstallationAndPowerSource;
  recommendedTariff: string = '';
  typeOfMeter?: string='';
  rating?: string = '';
  ctRating?: string = '';
  vtRating?: string = '';
  boxSeal?: string = '';
  ttbSeal?: string = '';
  ctSeal?: string = '';
  meterTypeDetails:string='';
  areaId: number = 0;
  subgeographicalRegionId: number = 0;
  phoneNo: string = '';
  mapId: string = '';

  constructor(data?: any) {
 
    this.accountName = data?.accountName ?? '';
    this.accountNumber = data?.accountNumber ?? '';
    this.address = data?.address ?? '';
    this.physicalAddress = data?.physicalAddress ?? '';
    this.areaName = data?.areaName ?? '';
    this.buildingOwner = data?.buildingOwner ?? '';
    this.customerId = data?.customerId ?? 3;
    this.customerType = data?.customerType ?? '';
    this.email = data?.email ?? '';
    this.latitude = data?.latitude ?? 0;
    this.longitude = data?.longitude ?? 0;
    this.meterStatus = data?.meterStatus ?? '';
    this.name = data?.name ?? '';
    this.oldMeter = data?.oldMeter ?? '';
    this.regionName = data?.regionName ?? '';
    this.spn = data?.spn ?? '';
    this.tarifId = data?.tarifId ?? 0;
    this.tarifName = data?.tarifName ?? '';
    this.tarifRate = data?.tarifRate ?? '';
    this.typeOfConnection = data?.typeOfConnection ?? '';
    this.geoCode = data?.geoCode ?? '';
    this.readingOnMeter = data?.readingOnMeter ?? '';
    this.ghanaPostGPS = data?.ghanaPostGPS ?? '';
    this.activityCode = data?.activityCode ?? '';
    this.currentPlotCode = data?.currentPlotCode ?? '';
    this.meterManufacturer = data?.meterManufacturer ?? '';
    this.meterSealNumber = data?.meterSealNumber ?? '';
    this.meterSimNo = data?.meterSimNo ?? '';
    this.meterSerialNumber = data?.meterSerialNumber ?? '';
    this.meterType = data?.meterType ?? '';
    this.meterNumber = data?.meterNumber ?? '';
    this.sltStatus = data?.sltStatus ?? '';
    this.installationAndPowerSource =  data?.installationAndPowerSource ?? '';
    this.recommendedTariff = data?.recommendedTariff ?? '';
    this.typeOfMeter = data?.typeOfMeter ?? '';
    this.rating = data?.rating ?? '';
    this.ctRating = data?.ctRating ?? '';
    this.vtRating = data?.vtRating ?? '';
    this.boxSeal = data?.boxSeal ?? '';
    this.ttbSeal = data?.ttbSeal ?? '';
    this.ctSeal = data?.ctSeal ?? '';
    this.meterTypeDetails = data?.meterTypeDetails?.replace("_"," ") ?? '';
    this.areaId = data?.areaId ?? 0;
    this.subgeographicalRegionId = data?.subgeographicalRegionId ?? 0;
    this.phoneNo = data?.phoneNo ?? '';
    this.mapId = data?.mapId ?? '';
  }
}
export class InstallationHistory {
  comment: string = '';
  timeStamp: string = '';
  action: string = '';
  user: string = '';

  constructor(data?: any) {
    this.comment = data?.comment ?? '';
    this.timeStamp = data?.timeStamp ?? '';
    this.action = data?.action ?? '';
    this.user = data?.user ?? '';
  }
}
export interface DtInstallationPeriod {
  vendorId: number;
  vendorName: string;
  year: number;
  month: number;
  recordCount: number;
}

export enum OtpAction {
  ApproveDtMeterInstallationMeter = 'ApproveDtMeterInstallationMeter',
  ApproveDtMeterInstallationInvoice = 'ApproveDtMeterInstallationInvoice',
}
